import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { ButtonBack, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import ContentHeading from '../../../components/layout/content/ContentHeading';
import InputTextField from '../../../components/input/inputTextField';
import { RemoveRedEyeOutlined, SearchOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateTimeToView } from '../../../utils/date.utils';
import SwitchCustom from '../../../components/switch/SwitchCustom';
import { useDispatch } from 'react-redux';
import ModalCustom from '../../../components/modal/ModalCustom';
import { alertActive, swalError, swalSuccess } from '../../../components/alert/swal';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { MeetingTypeApi } from '../../../api/meeting-type/meeting-type.api';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';
import { ThesisCategoryApi } from '../../../api/thesis-category/thesis-category.api';
import { routeName } from '../../../routes/routeName';
import { ExaminationCalendarApi } from '../../../api/examination-calendar/examination-calendar.api';
import { ThesisBookApi } from '../../../api/thesis-book/thesis-book.api';
import { Grid, Typography } from '@mui/material';

const defaultState = {
    id_thesis_category: 0,
    thesis_category_name: undefined,
}
export default function StudentsEThesisLibrary() {
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [form, setForm] = useState<any>(defaultState)
    const [type, setType] = useState<string>("CREATE");

    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };


    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };

            const res = await ThesisBookApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit,]);

    useEffect(() => {
        loadData();
    }, [loadData]);


    return (
        <div>
            <ContentHeading
                title={t("ห้องสมุด E-Thesis")}
                detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
            />

            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหา ชื่อหมวดหมู่วิทยานิพนธ์")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>


            </div>

            <section className="w-full mt-10">
                <Grid container spacing={2}>
                    {data?.map((item: any, index: number) => {
                        return (
                            <Grid item lg={12 / 5} key={index}>
                                <div style={{
                                    boxShadow: '0px 0px 7px -2px #1018281A',
                                    padding: '16px',
                                    borderRadius: '16px',
                                    minHeight:'360px'
                                }} onClick={() => {
                                    navigate(routeName.students.DetailEThesisLibrary.replace(':id', item?.id_thesis_book))
                                }}>
                                     <img src={process.env.REACT_APP_FILE_BASE_API + '/' + item?.thesis_book_cover?.file_path + item?.thesis_book_cover?.file_name} style={{width:'100%', height:'200px', objectFit:'cover', objectPosition:'center'}}/>
                                    {/* <ImageLoader id={item?.thesis_book_cover?.id_thesis_book_file} file_type={item?.thesis_book_cover?.file_type} /> */}
                                    <Typography sx={{fontWeight:'600', marginTop:'10px'}}>{item?.thesis_book_name}</Typography>
                                    <Typography sx={{ fontSize: '14px' }}>ผู้จัดทำ: {item?.thesis_book_created}</Typography>
                                    <Typography sx={{ fontSize: '14px' }}>ประเภท: {item?.thesis_type_name}</Typography>
                                    <Typography sx={{ fontSize: '14px' }}>หมวดหมู่: {item?.thesis_category_name}</Typography>
                                </div>
                            </Grid>
                        )
                    })}

                </Grid>
            </section>

        </div>
    )
}

const ImageLoader = (props:any) => {
    const {id, file_type} = props
    const [url, setUrl] = useState<any>('')
    const getImg = async () => {
        await ThesisBookApi.downloadfile(id).then((res: any) => {
            if (res.status < 300) {
                const blobFile = new Blob([res?.data], { type: file_type === 'png' ? 'image/png' : 'image/jpeg' })
                const url = URL.createObjectURL(blobFile);
                setUrl(url)
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    useEffect(() => {
        getImg()
    }, [])
    return (
        <img src={url} />
    )
}
